/* eslint-disable */
import api from '@/api/comment'
import CheckSeal from '../components/eseal/checkSeal'
import sealCom from '../components/eseal/pc.vue'
import { getContextPath } from 'utils'
import cloneDeep from 'lodash.clonedeep'
import {
  toString,
  isPlainObject,
  isDef
} from 'utils'
const contextPath = getContextPath()

function createVm() {
  const SealConstructor = Vue.extend(sealCom)
  const instance = new SealConstructor({
    el: document.createElement('div')
  })
  return instance
}

function Handler() {
  const that = this
  if (window.handler) {
    return window.handler
  }
  //显示盖章，添加盖章也调用该方法
  this.run = function(params) {
    that.vm.$nextTick(() => {
      var width = params.width || 130
      var height = params.height || 130
      var top = 0
      var left = 0
      var src = params.url || params.sealBase64
      $("#" + params.domId).append(
        "<img id='" + params.uuid + "' src=" +
        src +
        " style='position: absolute;top:" +
        top +
        "px;left:" +
        left +
        "px;width:100%;" +
        "height:" +
        "100%'> "
      )
      //添加点击事件
      $("#" + params.domId).on("click", function() {
        that.sealCom.checkSeal(params)
        that.checkSealVm = CheckSeal()
      })
    })

    //
  }

  this.addLose = function(params, checkInfo) {
    var width = params.width || 130
    var height = params.height || 130
    var top = 0
    var left = 0
    $("#" + params.domId).find('.lose').remove()
    $("#" + params.domId).append(
      "<div class='lose' style='position: absolute;top:" +
      top +
      "px;left:" +
      left +
      "px;width:100%;" +
      "height:" +
      "100%'>失效</div>"
    )
    //验证失败后截图update系统已经存进去的签章
    this.loseCallBack && this.loseCallBack(params, checkInfo)
  }

  //自定义验签数据,丢入保护项数组,dom上查找相应id的表单value
  this.verifyData = function(list) {
    return list
  }

  this.chooseSeal = (item) => {
    if (item.ishand) {
      const obj = {}
      obj['alias'] = '手绘签名'
      obj['sealId'] = item['sealUUID']
      obj['sealFile'] = item['sealBase64']
      this.choosedSealData = obj
    } else {
      this.choosedSealData = item
      if (this.choosedSealData)
        this.choosedSealData.sealFile = 'data:image/png;base64' + ',' + this.getBase64(this.choosedSealData)
    }
  }  
  this.deletedSeal = () => {
    this.choosedSealData = null
    //已经签署过了
    if (this.hasSigned) {
      //需要删除存储在业务系统的e签宝签章
      this.vm.chapterWID && this.vm.deleteJGseal(this.vm.chapterWID, () => {
        this.hasSigned = false
      })
    }
  }
  // this.severUrl = "http://116.62.162.13:9297" //后端服务地址
  this.url = window.location.origin + contextPath + "/sys/eetablecore/form_render/static/yb/handwrite.html" //前端页面的路径
  // this.url = 'http://172.31.29.74:8080/emap/sys/eetablecore/form_render/static/yb/handwrite.html'
  this.setBusinessProcessId = function(id) {
    this.businessProcessId = id
  }
  this.setUserInfo = function(info) {
    this.setUserInfo = info
  }
  this.setContract = function(obj) {
    this.contract = obj
  }
  this.setProtect = function(list) {
    return list
  }
}

//初始化逻辑首先设置签章列表对应得位置setPos,然后设置设置签章要对比验证的数据verifyData,接着内部调用run进行印章绘制绘制完成后,用户手动调用verify进行所有签章列表验证
Handler.prototype = {
  init(userInfo, serverUrl) {
    this.severUrl = serverUrl
    this.userInfo = userInfo
    // this.userInfo = {
    //   createTime: "",
    //   departmentName: "",
    //   id: "538bc547-96a4-4f4e-bdf2-2009a166bd30", //用户登录id
    //   licenseNumber: "",
    //   licenseType: 0,
    //   mobile: "18672794072",
    //   name: "",
    //   type: 0,
    //   uniqueId: "zyh", //用户唯一标识
    // }
  },
  normalizeProtectedItems(protectedItems) {
    if (protectedItems && isPlainObject(protectedItems)) {
      const newProtectedItems = cloneDeep(protectedItems)
      const obj = {}
      if (this.vm && this.vm.eseal && this.vm.eseal.protectedItems && Array.isArray(this.vm.eseal.protectedItems)) {
        const esealProtectedItems = this.vm.eseal.protectedItems
        esealProtectedItems.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(newProtectedItems, key)) {
            let val = newProtectedItems[key]
            if (!/^___/.test(key) && !/_DISPLAY$/i.test(key)) {
              obj[key] = (isDef(val) && typeof(val) === 'object') ? val : toString(val)
            }
          }
        })
      } else {
        Object.keys(newProtectedItems).forEach((key) => {
          let val = newProtectedItems[key]
          if (!/^___/.test(key) && !/_DISPLAY$/i.test(key)) {
            obj[key] = (isDef(val) && typeof(val) === 'object') ? val : toString(val)
          }
        })
      }
      return obj
    } else {
      return {}
    }
  },
  addSeal(callback, signlogId) {
    if (this.choosedSealData) {
      const sealObj = {
        name: this.choosedSealData['alias'],
        sid: signlogId,
        sealFile: this.choosedSealData['sealFile'],
        mimetype: '.png',
        type: this.vm && this.vm.signatureType
      }
      api.addJGSeal(sealObj).then((res) => {
        if (res && res.code === "0" && res.datas && res.datas.addJGSeal) {
          this.vm.chapterWID = res.datas.addJGSeal
          console.log('印章ID', this.vm.chapterWID)
          this.vm.emitInput()
          //标记签署成功过了
          this.hasSigned = true
          typeof(callback) === 'function' && callback()
        } else {
          this.vm.$Message.error(res.msg)
        }
      }).catch(err => {
        this.vm.$Message.error('盖章失败!')
      })
    } else {
      typeof(callback) === 'function' && callback()
    }
  },
  bindSubmit(vm, comp, serverUrl, userInfo) {
    //渲染当前印章得组件实例
    this.choosedSealData = null
    this.hasSigned = false
    this.vm = vm
    if (comp) {
      this.sealCom = comp
    } else {
      this.sealCom = createVm()
    }
    this.eSubmit = (callBack) => {
      console.log('选择的印章', this.choosedSealData)
      console.log('是否签过', this.hasSigned)
      if (this.choosedSealData && !this.hasSigned) {
        this.sealCom.submit()
        this.submitHook = (signlogId) => {
          this.addSeal(callBack, signlogId)
        }
      } else {
        callBack && callBack()
      }
    }
    this.setProtect = () => {
      const verifyData = this.vm.getVerifyData && this.vm.getVerifyData()
      const protectedMap = this.normalizeProtectedItems(verifyData)
      return JSON.stringify(protectedMap)
    }
    //设置每个章的校验数据
    this.verifyData = (obj) => {
      try {
        obj = JSON.parse(obj)
      } catch (e) {
        obj = {}
      }
      const verifyData = this.vm.getVerifyData && this.vm.getVerifyData()
      const protectedMap = this.normalizeProtectedItems(verifyData)
      Object.keys(obj).forEach(key => {
        if (isDef(protectedMap[key])) {
          obj[key] = protectedMap[key]
        }
      })
      return obj
    }
    //渲染已盖签章后进行验证
    this.loadSignature = () => {
      this.sealCom.checkSealAll()
    }
    
    this.loadingSignatures = () => {
      this.sealCom.reFindSealList()
    }
    
    const businessProcessId = this.vm.eseal && this.vm.eseal.documentid
    businessProcessId && this.setBusinessProcessId(businessProcessId)
    
    this.dialogShowLogic = () => {
      $('.bh-paper-pile-dialog-footer').hide()
    }
    this.dialogHideLogic = () => {
      $('.bh-paper-pile-dialog-footer').show()
    }
    
    this.loseCallBack = ({
      domId,
      sealRequestId,
      signlogId
    }, checkInfo) => {
      if (this.checkSealVm)
        this.checkSealVm.res = checkInfo
      const flowComment = this.vm && this.vm.esealMap && this.vm.esealMap[signlogId]
      //在数据库里是有效签章
      if (flowComment && flowComment['sealValid'] == '0') { 
        const dom = document.getElementById(domId)
        let copyDom
        if (dom) {
          const targetDom = $(dom)
          copyDom = targetDom.clone()
          const width = targetDom.width()
          const height = targetDom.height()
          $(copyDom).addClass('clone-kg-img-div')
          $('body').append(copyDom)
        }
        $(copyDom).find('img').on('load', () => {
          html2canvas && html2canvas(copyDom, {
            useCORS: true,
            backgroundColor: null,
          }).then((d) => {
            d = d.toDataURL("image/png")
            this.vm && this.vm.updateJGSeal && this.vm.updateJGSeal({sealFile: d, wid: flowComment['elecseal'], valid: '1'}, () => {
              flowComment['sealValid'] = '1'
            })
            copyDom && copyDom.remove()
          })
        })
      }
    }
    
    //验证成功的回调
    this.verifySuccess = ({
      domId,
      sealRequestId,
      signlogId
    }, checkInfo) => {
      if (this.checkSealVm)
        this.checkSealVm.res = checkInfo
      const flowComment = this.vm && this.vm.esealMap && this.vm.esealMap[signlogId]
      //在数据库里是无效签章
      if (flowComment && flowComment['sealValid'] == '1') { 
        const dom = document.getElementById(domId)
        let copyDom
        if (dom) {
          const targetDom = $(dom)
          copyDom = targetDom.clone()
          const width = targetDom.width()
          const height = targetDom.height()
          $(copyDom).addClass('clone-kg-img-div')
          $('body').append(copyDom)
        }
        $(copyDom).find('img').on('load', () => {
          html2canvas && html2canvas(copyDom, {
            useCORS: true,
            backgroundColor: null,
          }).then((d) => {
            d = d.toDataURL("image/png")
            this.vm && this.vm.updateJGSeal && this.vm.updateJGSeal({sealFile: d, wid: flowComment['elecseal'], valid: '0'}, () => {
              flowComment['sealValid'] = '0'
            })
            copyDom && copyDom.remove()
          })
        })
      }
    }
  },
  getBase64(params) {
    return this.sealCom && this.sealCom.getBase64(params)
  },
  setServerUrl(url) {
    this.serverUrl = url
  },
  setUserInfo(userInfo) {
    this.userInfo = userInfo
  }
}
export const initHandler = () => {
  window.handler = new Handler()
}
export default function(serverUrl, uniqueId) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: serverUrl + "/esignpro/rest/account/account",
      type: "post",
      headers: {
        "Content-Type": "application/json;charset=utf8",
        "Access-Control-Allow-Methods": "GET, POST, PUT,DELETE,OPTIONS,PATCH",
        "x-timevale-project-id": "1000000",
        "x-timevale-signature":
          "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
      },
      data: JSON.stringify({
        accountId: uniqueId || 0,
      }),
      success: function (data) {
        const userInfo = data.data
        userInfo.id = data.data.accountId
        resolve(userInfo)
      },
      error: function (data) {
        console.log("error")
        reject(data)
      }
    })
  })
}
